import { Component, input, model, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { User } from '../../../models/user.model';

/**
 * Fenetre « Changer le mot de passe » de la barre du haut.
 *
 * Presentationnel : les trois champs et les trois « oeil » sont des `model` (la barre les remet
 * a zero a l'ouverture), la validation et l'appel d'authentification restent a la barre
 * (sorties `submitted` et `closed`).
 */
@Component({
  selector: 'app-topbar-password-modal',
  standalone: true,
  imports: [NgClass, FormsModule, TranslateModule],
  templateUrl: './topbar-password-modal.component.html',
  styleUrls: [
    '../styles/topbar-partage-01.css',
    '../styles/topbar-partage-04.css',
    '../styles/topbar-password-modal-01.css',
  ],
  styles: [':host { display: contents; }'],
})
export class TopbarPasswordModalComponent {
  readonly currentPwd = model<string>('');
  readonly newPwd = model<string>('');
  readonly confirmPwd = model<string>('');
  readonly showCurrentPwd = model<boolean>(false);
  readonly showNewPwd = model<boolean>(false);
  readonly showConfirmPwd = model<boolean>(false);

  readonly showPasswordModal = input.required<boolean>();
  readonly currentUser = input.required<User | null>();
  readonly pwdError = input.required<string>();
  readonly pwdSaving = input.required<boolean>();

  readonly closed = output<void>();
  readonly submitted = output<void>();
}
